import Lock from "@material-symbols/svg-500/rounded/lock.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

export const LockIcon = memo((props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Lock });
	return <Icon />;
});
